module.exports = __webpack_public_path__ + "static/media/papel-timbrado-mds-02.f62022f6.jpg";